/* #WearBrogi community — feed + photo upload (port of original `IK`, Supabase REST without supabase-js). */
(function () {
  if (customElements.get('community-feed')) return;

  function toast(msg, type, position) {
    if (window.BrogiToast && msg) BrogiToast.show(msg, { type: type || 'success', position: position });
  }

  class CommunityFeed extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.url = (this.dataset.supabaseUrl || '').replace(/\/+$/, '');
      this.key = this.dataset.supabaseKey || '';
      this.grid = this.querySelector('[data-feed-grid]');
      this.loading = this.querySelector('[data-feed-loading]');
      this.empty = this.querySelector('[data-feed-empty]');
      this.tpl = this.querySelector('template[data-post-template]');
      this.file = null;
      this.previewUrl = null;
      if (this.url && this.key) {
        this.load();
        this.initForm();
      }
    }

    headers(extra) {
      var h = { apikey: this.key, Authorization: 'Bearer ' + this.key };
      for (var k in extra || {}) h[k] = extra[k];
      return h;
    }

    load() {
      var self = this;
      var limit = parseInt(this.dataset.limit, 10) || 50;
      var q = this.url + '/rest/v1/community_posts?select=*&approved=eq.true&order=created_at.desc&limit=' + limit;
      fetch(q, { headers: this.headers() })
        .then(function (r) { return r.ok ? r.json() : []; })
        .catch(function () { return []; })
        .then(function (posts) { self.renderPosts(Array.isArray(posts) ? posts : []); });
    }

    renderPosts(posts) {
      var self = this;
      var curated = this.grid ? this.grid.children.length : 0;
      posts.forEach(function (p, i) {
        if (!p || !p.image_url || !self.tpl) return;
        var node = self.tpl.content.firstElementChild.cloneNode(true);
        node.setAttribute('data-reveal-delay', String(Math.round((curated + i) * 0.05 * 100) / 100));
        var img = node.querySelector('[data-post-img]');
        img.src = p.image_url;
        img.alt = (self.dataset.altTemplate || '[name] wearing [fragrance]')
          .replace('[name]', p.name || '').replace('[fragrance]', p.fragrance || '');
        node.querySelector('[data-post-name]').textContent = p.name || '';
        node.querySelector('[data-post-fragrance]').textContent = p.fragrance || '';
        var cap = node.querySelector('[data-post-caption]');
        if (p.caption) cap.textContent = p.caption; else cap.remove();
        var ig = node.querySelector('[data-post-ig]');
        if (p.instagram_handle) ig.href = 'https://instagram.com/' + encodeURIComponent(String(p.instagram_handle).replace('@', '').trim());
        else ig.remove();
        self.grid.appendChild(node);
      });
      var count = this.grid ? this.grid.children.length : 0;
      if (this.loading) this.loading.hidden = true;
      if (this.grid) this.grid.hidden = count === 0;
      if (this.empty) this.empty.hidden = count > 0;
      if (window.Brogi && Brogi.initReveal && this.grid) Brogi.initReveal(this.grid);
    }

    initForm() {
      var self = this;
      var form = this.form = this.querySelector('[data-community-form]');
      if (!form) return;
      this.input = form.querySelector('[data-photo-input]');
      this.drop = form.querySelector('[data-photo-drop]');
      this.preview = form.querySelector('[data-photo-preview]');
      this.previewImg = form.querySelector('[data-photo-preview-img]');
      this.submitBtn = form.querySelector('[data-community-submit]');

      this.input.addEventListener('change', function () {
        var f = self.input.files && self.input.files[0];
        if (!f) return;
        if (f.size > 5 * 1024 * 1024) {
          toast(self.dataset.msgTooLarge, 'error');
          self.input.value = '';
          return;
        }
        self.setFile(f);
      });
      form.querySelector('[data-photo-clear]').addEventListener('click', function (e) {
        e.preventDefault();
        self.setFile(null);
      });
      form.addEventListener('input', function () { self.validate(); });
      form.addEventListener('change', function () { self.validate(); });
      form.addEventListener('submit', function (e) { e.preventDefault(); self.submit(); });
    }

    setFile(f) {
      if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
      this.file = f;
      this.previewUrl = f ? URL.createObjectURL(f) : null;
      if (f) this.previewImg.src = this.previewUrl;
      else this.input.value = '';
      this.preview.hidden = !f;
      this.drop.hidden = !!f;
      this.validate();
    }

    values() {
      var fd = new FormData(this.form);
      return {
        name: String(fd.get('name') || ''),
        fragrance: String(fd.get('fragrance') || ''),
        caption: String(fd.get('caption') || ''),
        instagram_handle: String(fd.get('instagram_handle') || '')
      };
    }

    validate() {
      var v = this.values();
      this.submitBtn.disabled = !!this.busy || !this.file || !v.name || !v.fragrance;
    }

    setBusy(b) {
      this.busy = b;
      this.submitBtn.querySelector('[data-submit-idle]').hidden = b;
      this.submitBtn.querySelector('[data-submit-busy]').hidden = !b;
      this.validate();
    }

    submit() {
      var self = this;
      var v = this.values();
      if (!this.file || !v.name || !v.fragrance || this.busy) return;
      this.setBusy(true);
      var ext = (this.file.name.split('.').pop() || 'jpg');
      var path = Date.now() + '-' + Math.random().toString(36).slice(2) + '.' + ext;
      var body = new FormData();
      body.append('cacheControl', '3600');
      body.append('', this.file);
      fetch(this.url + '/storage/v1/object/community/' + path, {
        method: 'POST',
        headers: this.headers({ 'x-upsert': 'false' }),
        body: body
      })
        .then(function (r) { if (!r.ok) throw new Error('upload failed'); })
        .then(function () {
          return fetch(self.url + '/rest/v1/community_posts', {
            method: 'POST',
            headers: self.headers({ 'Content-Type': 'application/json', Prefer: 'return=minimal' }),
            body: JSON.stringify({
              name: v.name,
              fragrance: v.fragrance,
              caption: v.caption || null,
              image_url: self.url + '/storage/v1/object/public/community/' + path,
              instagram_handle: v.instagram_handle || null
            })
          });
        })
        .then(function (r) { if (!r.ok) throw new Error('insert failed'); })
        .then(function () {
          toast(self.dataset.msgSuccess, 'success', 'top-center');
          self.form.reset();
          self.setFile(null);
          var acc = self.querySelector('[data-community-accordion]');
          if (acc) {
            acc.classList.remove('is-open');
            var t = acc.querySelector('[data-accordion-toggle]');
            if (t) t.setAttribute('aria-expanded', 'false');
          }
        })
        .catch(function (err) {
          console.error(err);
          toast(self.dataset.msgError, 'error');
        })
        .then(function () { self.setBusy(false); });
    }
  }
  customElements.define('community-feed', CommunityFeed);
})();
